module.exports = __webpack_public_path__ + "static/media/regular.effbe9da.woff";